module.exports = __webpack_public_path__ + "img/business.b96e7f51.png";